export const VERIFIED_SOLUTION_OVERLAY_URL =
  'https://assetstorev1-prd-cdn.unity3d.com/banner/1d1a02bd-83bf-4b54-8222-f9d4bc1180a2.png';
